module.exports = __webpack_public_path__ + "static/media/portfolio-7.0301d890.jpg";